import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'pbg-page-home-router',
  templateUrl: './page-home-router.component.html',
  styleUrls: ['./page-home-router.component.scss']
})
export class PageHomeRouterComponent implements OnInit {
  client = false;

  constructor() {}

  ngOnInit() {
    this.client = environment.client;
  }
}
